/* Chip — small color-coded label. Used for tier/status badges and product tags. */
import React from "react";
import { P } from "../../shared/constants";
var E = React.createElement;

/* Use the "Dk" foreground variants on tinted backgrounds so small bold
   text still clears WCAG AA's 4.5:1 ratio. P.emerald/amber/coral on the
   matching Lt backgrounds was hitting ~3.5:1 — fails axe color-contrast. */
var VARIANTS = {
  default: { bg: "#E2E8F0",   fg: "#1F2937" },
  pri:     { bg: P.priLt,     fg: P.priDk     || P.pri },
  emerald: { bg: P.emeraldLt, fg: P.emeraldDk || P.emerald },
  amber:   { bg: P.amberLt,   fg: P.amberDk   || P.amber },
  coral:   { bg: P.coralLt,   fg: P.coralDk   || P.coral },
  slate:   { bg: P.bgS,       fg: P.slateM },
  /* PR-5.6: accent (cyan) for PA11Y PAYG + Watchtower Scan, and
     violet for Watchtower Remediate. Each v3 SKU gets a visually
     distinct chip so an enterprise customer on $1999/mo never sees
     a generic gray "FREE-looking" badge. */
  accent:  { bg: P.accentLt,  fg: P.accentDk  || P.accent },
  violet:  { bg: P.violetLt,  fg: P.violetDk  || P.violet }
};

/* Tier → variant lookup. PR-5.6 added the v3 SKU ids; the legacy
   keys (free/starter/pro/standard/enterprise/admin) stay so any
   un-migrated license row still renders a colored pill. */
var TIER_VARIANT = {
  /* Legacy tier ids (pre-v3) */
  free:       "default",
  starter:    "pri",
  pro:        "pri",
  standard:   "pri",
  enterprise: "amber",
  admin:      "coral",
  /* v3 preset ids (api/shared/license-presets.js PRESET_LIST) */
  pa11y_payg:           "accent",   // cyan — metered PAYG, distinct from free
  docmaya_trial:        "amber",    // time-limited feel
  docmaya_paid:         "emerald",  // paid product, success vibe
  watchtower_scan:      "pri",      // primary indigo — scan SKU
  watchtower_remediate: "violet"    // violet — clearly differentiated from scan-only
};

export default function Chip(props){
  var variant = props.variant
    || (props.tier && TIER_VARIANT[props.tier])
    || "default";
  var v = VARIANTS[variant] || VARIANTS.default;
  var size = props.size || "md";
  var pad = size==="sm"?"2px 7px":"4px 10px";
  var fs = size==="sm"?10:11;
  return E("span", {
    style:{display:"inline-flex",alignItems:"center",gap:4,padding:pad,
      borderRadius:999,background:v.bg,color:v.fg,fontSize:fs,fontWeight:700,
      lineHeight:1.4,whiteSpace:"nowrap"},
    title: props.title || undefined
  }, props.children);
}
